module.exports = __webpack_public_path__ + "media/images/alfiler-73c95556.png";